import { Route } from 'react-router-dom';
import { ReportGeneratorPage } from './report-generator';
import { ReportsLibraryPage } from './reports-library';
import { RequireAuth, UseActiveClient } from '/src/components';
import { RoleTypes } from '/src/lib/models';

export { ReportGeneratorPage, ReportsLibraryPage };

export const reportRoutes: React.ReactElement[] = [
  // Reports Library
  <Route
    path="/reports"
    element={
      <RequireAuth allowedRoles={[RoleTypes.FuseAdmin, RoleTypes.ClientAdmin]}>
        <UseActiveClient>
          <ReportsLibraryPage />
        </UseActiveClient>
      </RequireAuth>
    }
  />,

  // Report Generator
  <Route
    path="/reports/:report_slug"
    element={
      <RequireAuth allowedRoles={[RoleTypes.FuseAdmin, RoleTypes.ClientAdmin]}>
        <UseActiveClient>
          <ReportGeneratorPage />
        </UseActiveClient>
      </RequireAuth>
    }
  />,
];
